import { type ReactNode } from "react";
import { EmailProvider, type EmailOption } from "./EmailContext";
import GmailWrapperContent from "./GmailWrapperContent";
import "./index.css";

export interface EmailData {
  to: EmailOption[];
  cc: EmailOption[];
  bcc: EmailOption[];
  subject: string;
  body: string;
  attachments: File[];
  isReply?: boolean;
}

function GmailWrapper({
  fetchEmailOptions,
  handleChange,
  initialData,
  leftChildren,
  rightChildren,
  customTool,
  isReply,
  showOnlyBody,
  googleDriveConfig,
  aiContentComponent,
  aiContent,
  showAiPreview,
  onAiInsert,
  onAiDiscard,
  placeholder,
  minHeight = "400px",
  showAttachFile = true,
}: {
  fetchEmailOptions: (currentEmail: string) => Promise<EmailOption[]>;
  handleChange: (emailData: EmailData) => void;
  initialData?: Partial<EmailData>;
  leftChildren?: ReactNode;
  rightChildren?: ReactNode;
  customTool?: ReactNode;
  isReply?: boolean;
  showOnlyBody?: boolean;
  googleDriveConfig?: {
    clientId: string;
    apiKey: string;
  };
  // AI Integration
  aiContentComponent?: ReactNode;
  aiContent?: string;
  showAiPreview?: boolean;
  onAiInsert?: (content: string) => void;
  onAiDiscard?: () => void;
  placeholder?: string;
  minHeight?: string;
  showAttachFile?: boolean;
}) {
  return (
    <EmailProvider googleDriveConfig={googleDriveConfig}>
      <GmailWrapperContent
        fetchEmailOptions={fetchEmailOptions}
        handleChange={handleChange}
        initialData={initialData}
        isReply={isReply}
        leftChildren={leftChildren}
        rightChildren={rightChildren}
        customTool={customTool}
        showOnlyBody={showOnlyBody}
        aiContentComponent={aiContentComponent}
        aiContent={aiContent}
        showAiPreview={showAiPreview}
        onAiInsert={onAiInsert}
        onAiDiscard={onAiDiscard}
        placeholder={placeholder}
        minHeight={minHeight}
        showAttachFile={showAttachFile}
      />
    </EmailProvider>
  );
}

export default GmailWrapper;
